import { render, staticRenderFns } from "./DailyBookingDurationSettings.vue?vue&type=template&id=2c35542c&"
import script from "./DailyBookingDurationSettings.vue?vue&type=script&lang=ts&"
export * from "./DailyBookingDurationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports